import { getEnv } from "./EnvHelper";

// Resolves per-domain backend config from REACT_APP_DOMAIN_CONFIG (nested JSON).
// Each entry: { url, logoWidth?, logoHeight?, loginLogoWidth?, loginLogoHeight?, loginLogoTop?, loginLogoLeft? }
// Lookup order for "pacs.teliradx.com": full host → parent domain (last 2 parts).
export const resolveBackendForHost = (hostname) => {
  const empty = { matched: false, backendUrl: null, matchedDomain: null, logoWidth: null, logoHeight: null, loginLogoWidth: null, loginLogoHeight: null, loginLogoTop: null, loginLogoLeft: null };
  if (!hostname) return empty;

  const h = hostname.split(":")[0].toLowerCase();
  const parts = h.split(".");

  const candidates = [h];
  if (parts.length >= 2) candidates.push(parts.slice(-2).join("."));

  const domainConfig = getEnv("REACT_APP_DOMAIN_CONFIG") || {};

  for (const candidate of candidates) {
    const config = domainConfig[candidate];
    if (config?.url) {
      return {
        matched: true,
        backendUrl: config.url,
        matchedDomain: candidate,
        logoWidth: config.logoWidth || null,
        logoHeight: config.logoHeight || null,
        loginLogoWidth: config.loginLogoWidth || null,
        loginLogoHeight: config.loginLogoHeight || null,
        loginLogoTop: config.loginLogoTop || null,
        loginLogoLeft: config.loginLogoLeft || null,
      };
    }
  }

  return empty;
};
